import React, {useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import * as userActions from "redux/actions/userActions";
import NotificationList from "./NotificationList/index";
import { StyledBox } from "./style";
import "./style.css";
import CircularProgress from "@mui/material/CircularProgress";
import InfiniteScroll from "react-infinite-scroll-component";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { FormControlLabel, Switch } from "@mui/material";
import { LeaseEvent, Transaction, TransactionDeleteRequest, PreTransactionDeleteRequest } from "shared/utils";

const NotificationBox = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const allNotifications = useSelector(
    (state) => state.currentUser.notifications
  );
  const mentionNotifications = useSelector(
    (state) => state.currentUser.notifications?.filter(x => x.type !== LeaseEvent && x.type !== Transaction)
  );
  const leaseEventNotifications = useSelector(
    (state) => state.currentUser.notifications?.filter(x => x.type === LeaseEvent)
  );
  const transactionNotifications = useSelector(
    (state) => state.currentUser.notifications?.filter(x => x.type === Transaction)
  );
  const transactionDeleteRequestNotifications = useSelector(
    (state) => state.currentUser.notifications?.filter(x => x.type === TransactionDeleteRequest || x.type === PreTransactionDeleteRequest)
  );
  const [isloading, setloading] = useState(true);
  const userId = useSelector((state) => state.currentUser.details.id);
  const [value, setValue] = React.useState("1");
  const [ismoreLoading, setMoreLoading] = React.useState(false);
  const [notificationType, setNotificationType] = React.useState(1);
  const unreadCount = useSelector(
    (state) => state.currentUser.unReadNotification?.unReadNotificationCount ?? 0
  );
  const mentionsCount = useSelector(
    (state) => state.currentUser.unReadNotification?.unReadMentionsCount ?? 0
  );
  const leaseEventsCount = useSelector(
    (state) => state.currentUser.unReadNotification?.unReadLeaseEventsCount ?? 0
  );
  const transactionCount = useSelector(
    (state) => state.currentUser.unReadNotification?.unReadTransactionCount ?? 0
  );
  const transactionDeleteRequestCount = useSelector(
    (state) => state.currentUser.unReadNotification?.unReadTransactionDeleteRequestCount ?? 0
  );
  const userSettings = useSelector(
    (state) => state.currentUser.userSettings
  );
  const [localReadUnread, setLocalReadUnread] = useState(undefined);
  const [hasMore, setHasMore] = React.useState(true);
  const [pageNumber, setPageNumber] = React.useState(1);
  const selectedClient = useSelector((state) => state.clients.selectedClient);
  const selectedClientId = useSelector(
    (state) => state.clients.selectedClientId
  );
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuopen, setMenuOpen] = useState(false);
  // Delete-request feature (and its "Admin settings" notification tab) is
  // disabled for this release — see DELETE_REQUEST_FEATURE_ENABLED in
  // transactionMoreVertMenus.js. Hidden from every role, including Admins
  // and Account Leads, until that feature is re-enabled.
  const canSeeAdminSettingsTab = false;

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleChange = useCallback((event, newValue) => {
    if (userId && selectedClient?.clientId) {
      setHasMore(true);
      dispatch(userActions.resetNotifications());
      const noticeType = Number(newValue);
      setNotificationType(noticeType);
    }
    setPageNumber(1);
    setValue(newValue);
  }, []);

  const markAsRead = useCallback(
    (notificationId) => {
      Promise.all([
        dispatch(userActions.MarkNotificationsAsRead(userId, notificationId)),
      ])
        .catch((e) => {
          setloading(false);
          console.log(`Error: ${e}`);
        })
        .finally(() => {
          dispatch(
            userActions.getUnreadNotificationCount(userId, selectedClientId)
          );
          setloading(false);
        });
    },
    [dispatch, userId, selectedClientId]
  );

  const markAllAsRead = useCallback(() => {
    setloading(true);
    markAsRead(null);
  }, [markAsRead]);

  const fetchMoreData = () => {
    setMoreLoading(true);
    const nextPage = pageNumber + 1;
    setPageNumber(nextPage);
    if (userId && selectedClient?.clientId) {
      const request = {
        userId: userId,
        clientId: selectedClientId,
        pageNumber: nextPage,
        readUnread: localReadUnread,
        notificationType: notificationType,
      };
      dispatch(userActions.getNotifications(request))
        .then((response) => {
          setMoreLoading(false);
          if (response && response.payload.data) {
            if (response.payload.data.length < 20) {
              setHasMore(false);
            } else setHasMore(true);
          } else {
            setHasMore(false);
          }
        })
        .catch((error) => {
          setHasMore(false);
          setMoreLoading(false);
        });
    }
  };

  useEffect(() => {
    if (userId && selectedClient?.clientId && localReadUnread !== undefined ) { 
      dispatch(userActions.resetNotifications());
      const request = {
        userId: userId,
        clientId: selectedClientId,
        pageNumber: pageNumber,
        readUnread: localReadUnread,
        notificationType: notificationType,
      };
      setloading(true);
      dispatch(userActions.getNotifications(request))
        .then((response) => {
          setloading(false);
          setMoreLoading(false);
          if (response && response.payload.data) {
            if (response.payload.data.length < 20) {
              setHasMore(false);
            } else setHasMore(true);
          } else {
            setHasMore(false);
          }
        })
        .catch((error) => {
          setloading(false);
          setHasMore(false);
        });
    }
  }, [userId, selectedClientId, localReadUnread, notificationType]);

  const onSwitchChange = (event) => {
    const newValue = event.target.checked;
    setLocalReadUnread(newValue);
    userSettings.isReadOnly = newValue;
    setloading(true);
    dispatch(userActions.resetNotifications());
    dispatch(userActions.updateReadOnly(userSettings));
    setPageNumber(1);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

useEffect(() => {
  if (userId && selectedClientId) {
    dispatch(userActions.getUserSettings(userId, selectedClientId))
    .then((response) => {
      if (response && response.payload.data) {
          const isReadonly = response.payload.data.isReadOnly;
          setLocalReadUnread(isReadonly);
        }
    })
  }
}, [userId, selectedClientId]);

  const renderTabPanel = (value, data) => (
    <TabPanel key={value} value={value} className="tab-panel">
      <Box
        className={isloading ? "content-fade" : ""}
        sx={{ overflow: "auto", height: "70vh" }}
        id={`scrollableDiv-${value}`}
      >
        {data && (
          <InfiniteScroll
            dataLength={data.length}
            hasMore={hasMore}
            next={fetchMoreData}
            scrollableTarget={`scrollableDiv-${value}`}
          >
            <NotificationList
              data={data}
              onClose={onClose}
              loading={ismoreLoading}
            />
          </InfiniteScroll>
        )}
        {!isloading && (
          <div className="no-item">
            {data.length === 0 && (
              <Typography sx={{color:"#01151D"}}>You don't have any notifications.</Typography>
            )}
          </div>
        )}
      </Box>
      {isloading && (
        <Box className="loader-overlay">
          <Box className="loader">
            <CircularProgress size={32} sx={{ color: "#001F2B" }} />
          </Box>
        </Box>
      )}
    </TabPanel>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      scroll="paper"
      className="notification-box"
    >
      <StyledBox>
        <Box>
          <Box className="parent-box">
            <div className="menu-icon">
              <Typography
                id="modal-modal-title"
                className="modal-modal-title"
                variant="subtitle1"
              >
                Notifications
              </Typography>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={menuopen ? "long-menu" : undefined}
                aria-expanded={menuopen ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleMenuClick}
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
            </div>
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorEl}
              open={menuopen}
              onClose={handleMenuClose}
              slotProps={{
                paper: {
                  style: {
                    maxHeight: "88px",
                    width: "220px",
                  },
                },
              }}
            >
              <MenuItem>
                <FormControlLabel
                  control={
                    <Switch
                      checked={localReadUnread}
                      onChange={onSwitchChange}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#001F2B",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            background: "#001F2B",
                          },
                      }}
                    />
                  }
                  label="Show unread only"
                />
              </MenuItem>
            </Menu>
            <IconButton
              aria-label="close"
              onClick={onClose}
              color="default"
              fontSize="medium"
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className="mark-read-box">
            <Button
              onClick={markAllAsRead}
              size="small"
              variant="outlined"
              disabled={unreadCount === 0}
            >
              Mark all as read
            </Button>
          </Box>
          <TabContext value={value} id="modal-modal-description">
            <Box className="tab-list-box">
              <TabList
                onChange={handleChange}
                orientation="Horizontal"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="All" value="1" />
                <Tab label={`Mentions (${mentionsCount})`} value="2" />
                <Tab label={`Lease events (${leaseEventsCount})`} value="3" />
                <Tab label={`Transaction timeline (${transactionCount})`} value="4" />
                {canSeeAdminSettingsTab && (
                  <Tab label={`Admin settings (${transactionDeleteRequestCount})`} value="5" />
                )}
              </TabList>
            </Box>
            {renderTabPanel("1", allNotifications)}
            {renderTabPanel("2", mentionNotifications)}
            {renderTabPanel("3", leaseEventNotifications)}
            {renderTabPanel("4", transactionNotifications)}
            {canSeeAdminSettingsTab && renderTabPanel("5", transactionDeleteRequestNotifications)}
          </TabContext>
        </Box>
      </StyledBox>
    </Modal>
  );
};

export default NotificationBox;
